import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { painPoints } from '../constants/data';
export function PainPoints() {
  return <section className="w-full px-5 py-16 sm:py-24" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-202">
      <div className="mx-auto max-w-3xl" data-id="element-203">
        <Reveal data-id="element-204">
          <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight" data-id="element-205">
            Si sos joven en Argentina, esto te va a sonar familiar:
          </h2>
        </Reveal>

        <ul className="mt-10 space-y-4" data-id="element-206">
          {painPoints.map((point, i) => <motion.li key={point} initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex items-start gap-3 text-base sm:text-lg text-white/80" data-id="element-207">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" style={{
            backgroundColor: 'rgba(255,59,48,0.15)'
          }} data-id="element-208">
                <XIcon className="w-4 h-4" style={{
              color: '#FF3B30'
            }} strokeWidth={3} aria-hidden="true" data-id="element-209" />
              </span>
              {point}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-12 h-px w-2/3" style={{
        backgroundColor: '#00C853'
      }} data-id="element-210" />

        <Reveal data-id="element-211">
          <p className="mt-10 text-center text-xl sm:text-2xl lg:text-3xl font-bold leading-snug" data-id="element-212">
            ¿Cuántos meses más vas a llegar a cero sin entender por qué?
          </p>
        </Reveal>
      </div>
    </section>;
}